module.exports = __webpack_public_path__ + "img/xcg3.e8bf80b5.jpg";